<div class="flex flex-col h-full">
    <!-- En-tête -->
    <div class="flex items-center border border-gray-300 rounded-t-md bg-gray-50 px-4 py-3">
        <span class="flex-1 text-center font-semibold text-base">
            {{ 'vues.ipad.policies.headerTitle' | translate }}
        </span>
    </div>

    <!-- Contenu -->
    <div class="border-x border-b border-gray-300 rounded-b-md p-4">
        @if (url) {
        <div [ngClass]="{
            'h-[600px]': !policyAccepted,
            'h-[300px]': policyAccepted
        }">
            <app-pdf-viewer [url]="url" (isRead)="onPdfRead($event)"></app-pdf-viewer>
        </div>
        <div class="flex flex-col mt-4">
            <label class="flex items-center space-x-3 cursor-pointer py-3" [ngClass]="{
               'pointer-events-none': !pdfRead()
           }">
                <input
                    type="checkbox"
                    [disabled]="!pdfRead()"
                    [(ngModel)]="policyAccepted" (change)="onPolicyAcceptedChange($event)"
                    class="w-5 h-5 rounded border-gray-400 text-blue-600 focus:ring-blue-500 cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed" />
                <span class="text-gray-700 text-base">
                    {{ 'vues.ipad.policies.acceptanceText' | translate }}
                </span>
            </label>
        </div>
        }
        @if (showSignature && policyAccepted) {
        <app-signature-pad
            [height]="signatureHeight"
            [placeholder]="'vues.ipad.signaturePlaceHolder' | translate"
            (signatureChange)="onSignatureChange($event)">
        </app-signature-pad>
        }
    </div>
</div>